import { ZERO_UUID } from 'commons/constants/parse.js';

export const state = () => ({});

export const getQueue = (queue_uuid) => ({
    queue_uuid,
    workspace_uuid: ZERO_UUID,
    batch_uuid: ZERO_UUID,
    client_uuid: ZERO_UUID,
    name: '',
    note: '',
    outstanding_items: 0,
    urgent_items: 0,
    sla_millis: 0,
    expiry_date: 0,
    filters: [],
    content: [],
    active_users: [],
    unsaved_content: [],
    tag_list: {},
    filter_tag_list: {},
});
